import { render } from "./Home.vue?vue&type=template&id=2caa23ed&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2caa23ed&scoped=true&lang=scss"

import exportComponent from "/Users/ecm1922/Code/jakob-schloer.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2caa23ed"]])

export default __exports__